import {
    createMemberNote,
    updateMemberNote,
    type MemberId,
    type MemberNoteId,
} from '@wwf/sdk';
import { createNestedNotesProvider } from '../factories/createNestedNotesProvider';

export const memberNoteProvider = createNestedNotesProvider({
    parentKey: 'memberId',
    collection: 'members',
    createNote: (memberId, input) =>
        createMemberNote(memberId as MemberId, input),
    updateNote: (memberId, noteId, input) =>
        updateMemberNote(memberId as MemberId, noteId as MemberNoteId, input),
});
